import config from "../../config";
import {ICONCLASS} from "../constants";

export function facetName(facetType, key) {
    if (config.FACETS && config.FACETS.hasOwnProperty(key)) {
        return config.FACETS[key];
    }
    const facet = lookupTable[facetType][key];
    return typeof facet === 'string' ? facet : facet.name;
}


export function facetField(facetType, key) {
    const facet = lookupTable[facetType][key];
    return typeof facet === 'string' ? facet : facet.field;
}


export const lookupTable = {
    TIPE: config.TYPES,
    HIM: config.HIM,
    ICPATH: ICONCLASS
};
